<template>
  <minimal-layout>
    <div scroll-region class="min-h-screen bg-white">
      <flash-messages />
      <div class="a11y-scope">
        <slot />
      </div>
      <floating-admin-bar />
    </div>
  </minimal-layout>
</template>

<script>
import { router } from '@inertiajs/vue3';
import MinimalLayout from '@/Layouts/Minimal.vue';
import FlashMessages from '@/Shared/FlashMessages.vue';
import FloatingAdminBar from '@/Shared/FloatingAdminBar.vue';
import { scrollToAnchorFromHash } from '@/utils/scrollToAnchor';

export default {
  components: {
    MinimalLayout,
    FlashMessages,
    FloatingAdminBar,
  },
  data() {
    return {
      cancelHashScroll: null,
      removeInertiaSuccessListener: null,
      removeHashChangeListener: null,
    };
  },
  mounted() {
    // Direct URL with hash (e.g. /klinika#nasze-podejscie): scroll once block
    // sections exist. Instant scroll avoids a visible jump after hydration.
    this.scheduleHashScroll({ smooth: false });

    this.removeHashChangeListener = () => {
      window.removeEventListener('hashchange', this.onHashChange);
    };
    window.addEventListener('hashchange', this.onHashChange);

    // Same layout persists across Inertia visits; re-run after each navigation.
    this.removeInertiaSuccessListener = router.on('success', () => {
      this.scheduleHashScroll({ smooth: false });
    });
  },
  beforeUnmount() {
    this.clearHashScroll();
    this.removeHashChangeListener?.();
    this.removeInertiaSuccessListener?.();
  },
  methods: {
    clearHashScroll() {
      this.cancelHashScroll?.();
      this.cancelHashScroll = null;
    },
    scheduleHashScroll(options) {
      this.clearHashScroll();
      this.cancelHashScroll = scrollToAnchorFromHash(options);
    },
    onHashChange() {
      this.scheduleHashScroll({ smooth: true });
    },
  },
};
</script>
